// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__L3dfW","spinner":"Loader_spinner__az2rQ","spin":"Loader_spin__Z+GTY"};